<script>
import { Bar } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes';

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}


export default {
  extends: Bar,
  props: ['data'],
  mounted () {
    const dates = this.data.map(d => d.date).filter(onlyUnique);
    const agents = this.data.map(d => d.agent).filter(onlyUnique);
    const colors = agents.map(getRandomColor);
    const map = {};
    agents.forEach(agent => {
      map[agent] = {};
    });
    this.data.forEach(entry => {
      map[entry.agent][entry.date] = entry.count;
    });

    const data = {
      labels: dates,
      datasets: agents.map((agent, a) => {
        return {
          label: agent,
          data: dates.map(date => {
            return map[agent][date] || 0;
          }),
        };
      }),
    };
    const options = {
      scales: {
        yAxes: [{
          stacked: true
        }],
        xAxes: [{
          stacked: true
        }]
      },
      plugins: {
        colorschemes: {
          scheme: 'brewer.Paired12'
        }
      }
    }
    this.renderChart(data, options);
  }
}
</script>
